import { render } from "./consensusSection.vue?vue&type=template&id=a9952bf8"
import script from "./consensusSection.vue?vue&type=script&lang=js"
export * from "./consensusSection.vue?vue&type=script&lang=js"

import "./consensusSection.vue?vue&type=style&index=0&id=a9952bf8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__